import {
	ActionItem,
	voidFunc
} from "../../components/DesignSystem/Menu/Actionitem";
import { useContext /*useRef*/ } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType } from "../../context/AuthProvider";
import { useDrawer } from "../../components/DesignSystem/Trays/DrawerStateProvider";
import { useModalState } from "../../components/DesignSystem/Modal/ModalStateProvider";
import useStripe from "./useStripe";
import { useServer } from "../../services/api-client/useServer";
// import { useSnackbar } from "../../services/api-client/useSnackbar";
import {
	JobStatesValues,
	JobCardData,
	DONE
} from "../../DataModels/DataModels";

export function useMenuItems() {
	const { logout } = useContext(AuthContext) as AuthContextType;
	const { showTray } = useDrawer();
	const { customerPortalUrl } = useStripe();
	const { openModal } = useModalState();
	const navigate = useNavigate();
	// const {showSnack} = useSnackbar();
	const jobServer = useServer();

	return {
		profileActions: [
			{
				actionText: "Account",
				actionFunc: showTray
			},
			{
				actionText: "Manage Payment",
				actionFunc: () => {
					if (!customerPortalUrl) return;
					window.open(customerPortalUrl.toString(), "_blank");
				}
			},
			{
				actionText: "Archived Jobs",
				actionFunc: () => {
					navigate("/arc");
				}
			},
			{
				actionText: "Logout",
				actionFunc: () => {
					console.log("User requested Logout.");
					logout().then(() => {
						console.log("Logged Out.");
					});
				}
			},
			{
				actionText: "Contact Us",
				actionFunc: () => openModal("ContactUs")
			}
		] as ActionItem<voidFunc>[],

		trackActions: [
			{
				actionText: "new application",
				actionFunc: () => openModal("AddJob")
			}
			// {
			// 	actionText: "Existing Application",
			// 	actionFunc: () => openModal("AddExistingJob")
			// }
			// {
			//     actionText: "Job Lead",
			//     actionFunc: () => openModal("AddLead")
			// }
		] as ActionItem<voidFunc>[],

		menuItems: [
			{
				actionText: "Open",
				actionFunc: (key: JobCardData) => {
					navigate(`/job/${key.id}`);
				}
			},
			// { actionText: "Copy Cover Letter", actionFunc: (key: JobCardData) => {} },
			// { actionText: "Copy Resume", actionFunc: (key: JobCardData) => {} },
			{
				actionText: "Advance Status ",
				actionFunc: (key: JobCardData) => {
					const nextState =
						JobStatesValues[JobStatesValues.indexOf(key.state) + 1];

					jobServer.UpdateJobState(key.id.toString(), key.state, nextState);
				}
			},
			{
				actionText: "Archive Job",
				actionFunc: (key: JobCardData) => {
					jobServer.UpdateJobState(key.id.toString(), key.state, DONE);
				}
			}
		] as ActionItem<JobCardData>[]
	};
}
